<template>
  <div class="realEstatePanel">
    <div class="mt-2">
      <!-- Header: New Electricity -->
      <div class="d-flex">
        <i class="fas fa-bolt" style="margin-right: 2px"></i>
        <h4 class="mb-0 ml-50">
          {{ msg('Update') }}
        </h4>
      </div>

      <!-- Form: Electricity Info -->
      <b-row class="mt-1">

        <b-col cols="12">
          <b-row>
            <b-col cols="4" align-self="center">
              <b-img :src="electricity.imageUri" fluid thumbnail style="max-width: 240px; max-height: 300px"/>
            </b-col>
            <b-col cols="8">
              <b-row>
                <b-col cols="12">
                  <b-form-group :label="msg('Provider')">
                    <b-input v-model="electricity.provider"/>
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group :label="msg('Operator')">
                    <b-input v-model="electricity.operator"/>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
        <!-- WiFi Name -->
        <b-col cols="6">
          <b-form-group :label="msg('Electricity box')">
            <v-select
                v-model="electricity.electroBox"
                :options="[
        { value: 'manual', text: msg('Manual') },
        { value: 'smartmeter', text: msg('Smartmeter') }
      ]"
                placeholder="Select an option"
                label="text"
                :reduce="(status) => status.value"
            />
          </b-form-group>
        </b-col>


        <!-- Phone Number -->
        <b-col cols="6">
          <b-form-group :label="msg('Support phone')">
            <b-form-input v-model="electricity.phoneSupport" type="tel"/>
          </b-form-group>
        </b-col>

        <!-- KW Usage -->
        <b-col cols="6">
          <b-form-group :label="msg('KW Usage')">
            <b-form-input v-model="electricity.kwUsage" type="number"/>
          </b-form-group>
        </b-col>
        <!-- partialAmount  -->
        <b-col cols="6">
          <b-form-group :label="msg('Partial amount')">
            <b-form-input v-model="electricity.partialAmount" type="number"/>
          </b-form-group>
        </b-col>


        <!-- Electricity Password -->
        <b-col cols="6">
          <b-form-group :label="msg('Electricity Password')">
            <b-form-input v-model="electricity.electricityPassword"/>
          </b-form-group>
        </b-col>

        <!-- Last Charge -->
        <b-col cols="6">
          <b-form-group :label="msg('Registered')">
            <b-form-datepicker v-model="electricity.registered"/>
          </b-form-group>
        </b-col>


        <!-- Account -->
        <b-col cols="6">
          <b-form-group :label="msg('Account')">
            <b-form-input v-model="electricity.account"/>
          </b-form-group>
        </b-col>

        <!-- Password -->
        <b-col cols="6">
          <b-form-group :label="msg('Password')">
            <b-form-input v-model="electricity.password"/>
          </b-form-group>
        </b-col>

        <!-- Account -->
        <b-col cols="6">
          <b-form-group :label="msg('Counter')">
            <b-form-input v-model="electricity.counter"/>
          </b-form-group>
        </b-col>

        <!-- Password -->
        <b-col cols="6">
          <b-form-group :label="msg('Type')">
            <b-form-input v-model="electricity.electricityType"/>
          </b-form-group>
        </b-col>


        <!-- Status -->
        <b-col cols="6">
          <b-form-group :label="msg('Status')">
            <v-select
                v-model="electricity.status"
                :options="electricityStatus"
                class="w-100"
                label="text"
                :reduce="(status) => status.value"
            />
          </b-form-group>
        </b-col>

        <!-- Login Link -->
        <b-col cols="6">
          <b-form-group :label="msg('Link')">
            <b-form-input v-model="electricity.link"/>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group :label="msg('Image Uri')">
            <b-input v-model="electricity.imageUri"/>
          </b-form-group>
        </b-col>

        <!-- Branch ID -->
        <b-col cols="12">
          <b-form-group :label="msg('Branch')">
            <v-select
                v-model="electricity.buid"
                :options="allBranches"
                class="w-100"
                label="name"
                :reduce="(branch) => branch.id"
                :clearable="false"

            />
          </b-form-group>
        </b-col>


        <b-col cols="12">
          <b-form-group :label="msg('Real estate')">
            <real-estate-picker multiple v-model="electricity.propertyIds"/>
          </b-form-group>
        </b-col>
      </b-row>
      <!--files-->
      <b-row>
        <b-col cols="12">
          <b-card style="height: auto;" border-variant="warning">
            <div>
              <div class="card-header d-flex justify-content-between align-items-center">
                <div class="d-flex">
                  <feather-icon icon="FileIcon" size="19"/>
                  <h4 class="mb-0 ml-50">
                    {{ msg('Files').toUpperCase() }}
                  </h4>
                </div>
                <div>
                  <b-button size="sm" v-bind:variant="uploadFile ? 'warning' : 'outline-warning'"
                            @click="() => uploadFile = !uploadFile">
                    <i class="fas fa-upload"></i> {{ msg("Upload file") }}
                  </b-button>
                </div>
              </div>

              <div class="files-data">
                <div class="upload-backdrop" v-show="uploadFile === true">
                  <vue-dropzone id="contract-upload" class="h-100 darkcustom" :options="dropzoneOptions"
                                :useCustomSlot="true"
                                :duplicateCheck="true" @vdropzone-complete="uploadComplete"
                                @vdropzone-success="uploadSuccess">
                    <div class="dropzone-custom-content">
                      <h3 class="dropzone-custom-title">Drag and drop to upload content!</h3>
                      <div class="subtitle">...or click to select a file from your computer</div>
                    </div>
                  </vue-dropzone>
                </div>
                <b-table-simple outlined>
                  <b-tr style="background-color: #c2aa8e !important;">

                    <b-th class="text-center" style="width: 40%;color: white">{{ msg('File') }}</b-th>
                    <b-th class="text-center" style="width: 20%;color: white">{{ msg('Note') }}</b-th>
                    <b-th class="text-center" style="width: 15%;color: white">{{ msg('Operations') }}</b-th>
                  </b-tr>
                </b-table-simple>
                <perfect-scrollbar class="position-relative" style="height: auto">
                  <b-table-simple outlined>
                    <b-tr v-for="(file, index) in (electricity.files || [])" v-bind:key="file.id"
                          style="white-space: nowrap; text-overflow: ellipsis" v-show="file.active">
                      <b-td style="width: 30%">
                        <i v-bind:class="file.filename" class="mx-1"
                           style="font-size: 30px; font-weight: bold"></i>{{ file.filename }} <span
                          v-if="file.size != null" style="color: red!important;">{{ getFileSize(file.size) }}</span>
                      </b-td>
                      <b-td class="text-center" style="width: 20%">
                        <b-form-textarea v-model="file.notes" @change="() => submitDocumentFile(index)"
                                         size="sm"></b-form-textarea>
                      </b-td>
                      <b-td class="text-center" style="width: 15%">
                        <b-link class="mr-2"><i class="icon fas fa-download w-auto"
                                                @click="() => onDownloadFile(file.id)"></i></b-link>
                        <b-link><i class="icon fas fa-eye w-auto" @click="() => onPreviewFile(file.id)"></i>
                        </b-link>
                      </b-td>
                    </b-tr>
                  </b-table-simple>
                </perfect-scrollbar>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <!-- Save Button -->
      <div style="float: right">
        <b-button v-if="electricity.buid!=null && electricity.provider!=null" variant="outline-primary"
                  class="btn-dialog" @click="update">
          {{ msg('Update') }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>

import {mapActions, mapGetters} from 'vuex'
import RealEstatePicker from "@/components/components/picker/realEstatesPicker.vue";
import {msg} from "@babel/core/lib/config/validation/option-assertions";
import vue2Dropzone from "vue2-dropzone";

export default {
  name: 'editElectricityPanel',

  components: {
    RealEstatePicker,
    vueDropzone: vue2Dropzone
  },
  data() {
    return {
      loaded: false,
      contractId: null,
      electricity: {},
      clientId: null,
      uploadFile: false,
      file: null,
      dropzoneOptions: {},
      contractList: [],
      //Listeners
      listeners: {
        submit: () => {
        }
      }
    }
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters('data', ['getAllBranches']),
    ...mapGetters('electricity', ['allElectricityStatus']),

    electricityStatus() {
      let $this = this;
      return this.allElectricityStatus.map(status => ({
        value: status.value,
        text: $this.msg(status.text)
      }))
    },


    allBranches() {
      return Object.values(this.getAllBranches)
    },
  },
  created() {
    let $this = this;

    this.loadElectricity()
    this.loadDropZone();

    this.$root.$on('crm::submitElectricity', (this.listeners.submit = () => {
      this.submit()
    }))
  },
  beforeDestroy() {
    this.$root.$off('crm::submitElectricity', this.listeners.submit)
  },
  methods: {
    msg,
    ...mapActions('electricity', ['getAllElectricitys', 'copySuccess', 'updateElectricity', 'getElectricityById']),
    ...mapActions('realEstateContracts', ['getAllByClients']),
    ...mapActions("document", ["downloadCustomFile"]),
    ...mapActions('electricity', ['updateDocumentFile']),

    uploadComplete(file, response) {
      let responseData = JSON.parse(file.xhr.responseText);
      let electricity = responseData.objects["Electricity"];
      this.electricity = electricity;
    },
    uploadSuccess(file, response) {
      try {
        if (response.data == null || response.data['Electricity'] == null)
          return;
        this.electricity = response.data['Electricity'];
      } catch (e) {
        console.error('uploadSuccess error', e)
      }
    },

    submitDocumentFile(index) {
      this.updateDocumentFile({
        id: this.electricity.id,
        file: this.electricity.files[index]
      });
    },
    onDownloadFile(fileId) {
      let $this = this;
      this.downloadCustomFile({fileId: fileId}).then(file => {
        $this.asyncDownloadFile(file)
      })
    },
    onPreviewFile(fileId) {
      let $this = this;
      this.downloadCustomFile({fileId: fileId}).then(file => {

        let url = URL.createObjectURL(file.data);
        console.log("url is: ", url)
        window.open(url, '_blank')
      })
    },
    loadDropZone() {

      this.dropzoneOptions = {

        url: window.config.apiUrl + 'electricity/upload/file/' + this.id,
        headers: {'Authorization': `Bearer ${localStorage.Bearer}`},
        createImageThumbnails: false,
        thumbnailWidth: 200,
        thumbnailHeight: 200,
        addRemoveLinks: true,
        maxFilesize: 5000000,
        acceptedFiles: "image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.tsv,.ppt,.pptx",

      }
    },

    getFileSize(bytes, si = false, dp = 1) {
      const thresh = si ? 1000 : 1024;
      if (Math.abs(bytes) < thresh) {
        return '';
      }
      const units = si
          ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
          : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
      let u = -1;
      const r = 10 ** dp;
      do {
        bytes /= thresh;
        ++u;
      } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);
      return ' (' + bytes.toFixed(dp) + ' ' + units[u] + ')';
    },

    formatDate(date) {
      return date ? this.$moment(date, "YYYY-MM-DD").format("DD.MM.YYYY") : "No date";
    },
    loadElectricity() {
      let $this = this
      this.getElectricityById(this.id)
          .then(
              (electricity) => {
                $this.electricity = electricity

              },
              (a) => $this.$emit('submitted', {
                status: false,
                server: a
              })
          )
    },

    update() {
      let $this = this

      this.updateElectricity({electricity: this.electricity})
          .then(
              (id) => {

                $this.$emit('submitted', {status: true, server: id, id})

              },
              (a) => $this.$emit('submitted', {
                status: false,
                server: a
              })
          )
    },

    validate(field) {
      return this.$v.electricity[field] != null && this.$v.electricity[field].$error === true
    }
    ,
    submit() {
      return this.createElectricity()
    },

  },

}
</script>
<style scoped>

.dark-layout #realEstate-description {
  background-color: rgba(255, 255, 255, 0.66);
  color: #000000;
}

.quill-container #realEstate-description {

  min-height: 400px;
}

.dark-layout .darkcustom {
  background-color: #283046;
  color: #fff;
}
</style>


